require('./style.less');

var _ = require('underscore'),
	fvChannel = require('glRadio').channel('FV'),
	DrawablePageNoteView = require('../drawableNote');

/*
* Note: for now not sub-classing the floating - non floating note views.
* This would require a refactor of ViewConstructor on the note model to accept a function,
* and it may prove easier anyway when converting between note types.
*
* */


module.exports = DrawablePageNoteView.extend({

	templateHelpers: _.extend( {}, DrawablePageNoteView.prototype.templateHelpers, {

		isRedactionNote: function() {
			return true;
		},
		reasonCodes: function() { 
			return this.note.getUniqueListOfSavedReasonCodesForNoteView(); // null if none returned ...;
		},
		showConversionToFloatingCodes: function() {
			// cold cache this on init ...
			var parentPgIsCold = this.viewerChannel.request('activeDocPages').findWhere({ pageId: this.note.get('pageId') }).isCold();

			return fvChannel.request('applyFloatingReasonCodes') &&
				this.note.get('noteType') === 'REDACTION_NOTE' &&
				// Here interested in note edit perm;  quick code reuse taking adv of this fn already being on note view;
				// Could be more efficient but plan to move note perm logic to server anyway ( eg .. can modify )
				this.includeEditBtn() &&
				!parentPgIsCold ;
		}

	}),

	ui: _.extend( {}, DrawablePageNoteView.prototype.ui, {
		reasonCodesLabel:			'.note-sat-info-lbl',
		convertToFloatingCodesBtn:	'.btn-convert-to-floating',
		convertingIndicator:		'.redaction-convert-indicator'
	}),

	triggers: _.extend( {}, DrawablePageNoteView.prototype.triggers, {
		'click @ui.convertToFloatingCodesBtn': 'convertToFloatingCodes',
		'click @ui.editBtn': 'modifyClicked'
	}),

	_highlightDomForSATFilterToggle: function(satFilterTxt) {

		DrawablePageNoteView.prototype._highlightDomForSATFilterToggle.call(this, satFilterTxt);

		/*
		* Quick hack to ensure the reason codes label isn't highlighted in the UI.
		* see notes on base note object here
		* With faster browsers, now may be time to move to different method / plugin here for SAT filter
		* */
		this.ui.reasonCodesLabel.unhighlight();

	},
	/*
	* Show the converting indicator only in edit mode when converting.
	* Don't need to toggle back because view will be redrawn on save/edit.
	* ( And can't toggle edit/expanded in between active note toggle ).
	* */
	_postBaseToggleEditMode: function(isEntering) {

		DrawablePageNoteView.prototype._postBaseToggleEditMode.apply( this, arguments );

		if (isEntering && this.model.isConvertingToFloatingCodes)
			this.ui.convertingIndicator.removeClass('hide');

	},
	/*
	* Override base note view modify forward trigger.
	* If a floating redaction note and the system is not set for spider redactions,
	* show a warning dialog to proceed.
	* */
	onModifyClicked: function() {

		var args =  _.toArray(arguments),
			triggerBaseModifyEvent = function() {
				this.channel.trigger.apply( this.channel, ['noteView:enterEdit', this].concat( args ));
			};

		if ( !this.model.isFloatingRedactionAndSystemNotSetForFloatingCodes() ) {
			triggerBaseModifyEvent.call( this );
			return;
		}

		this.channel.request('vChannel').trigger( 'modal:open', {
			confirmType: 'warning',
			title: 'Confirm',
			content: 'This redaction contains data to display floating reason codes.  Modifying it will result in a loss of this data.  Do you wish to proceed?',
			okCB: _.bind( triggerBaseModifyEvent, this )
		});

	}

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/note/redaction/view.js
 ** module id = 231
 ** module chunks = 0
 **/